import React from "react";
import SessionState from "./SessionState";

export const SessionContext = React.createContext(new SessionState());
